export const secsDivisor = 1000;
export const minsDivisor = secsDivisor * 60;
export const hourDivisor = minsDivisor * 60;
export const dayDivisor = hourDivisor * 24;

export const padTime = (time: number) => {
  return time.toString().padStart(2, '0');
};

export interface DateParts {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

export const calculateDifference = (now: number, target: number): DateParts => {
  const difference = target - now;
  const dateParts: DateParts = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };
  if (difference <= 0) return dateParts;
  dateParts.days = Math.floor(difference / dayDivisor);
  dateParts.hours = Math.floor((difference % dayDivisor) / hourDivisor);
  dateParts.minutes = Math.floor((difference % hourDivisor) / minsDivisor);
  dateParts.seconds = Math.floor((difference % minsDivisor) / secsDivisor);
  return dateParts;
};

export const getDatePartsString = ({ days, hours, minutes, seconds }: DateParts, t: (str: string) => string) => {
  const dayString = `${days}${t('countdown-day')} `;
  const hourString = `${hours}${t('countdown-hour')} `;
  const minuteString = `${padTime(minutes)}${t('countdown-minute')} `;
  const secondString = `${padTime(seconds)}${t('countdown-second')}`;
  if (days > 0) return dayString + hourString + minuteString + secondString;
  if (hours > 0) return hourString + minuteString + secondString;
  if (minutes > 0) return minuteString + secondString;
  return secondString;
};

export const isCountdownComplete = ({ days, hours, minutes, seconds }: DateParts) => {
  return days === 0 && hours === 0 && minutes === 0 && seconds === 0;
};
